import "client-only";
import useSWR from "swr";
import { fetcher } from "../../utils/fetcher";
function useDistrictList(params) {
  return useSWR(
    !!params
      ? {
          path: `/api/v1/addresses/districts`,
          method: "GET",
          params,
        }
      : null,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnMount: true,
    },
  );
}

export default useDistrictList;
